import { Stack, Typography } from '@mui/material';
import FuelGun from 'app/icons/FuelGun';
import React from 'react';

import { paperProgressFuelTunkStyle } from '../TabPanelConditionStyle';

/**
 * Компонент для отображения индикатора заправочного пистолета (для топливозаправщика)
 */
export const FuelTankIndicator = ({ in5Value, galileoskyDevice, conditionItem }) => {
  const displayValue = galileoskyDevice && in5Value ? Math.round(in5Value) : '-';

  return (
    <Stack className='MuiPaperProgress-root' sx={(theme) => paperProgressFuelTunkStyle(theme, conditionItem)}>
      <div className='MuiPaperProgress-cover'>
        <Typography className='MuiPaperProgress-degrees' variant='caption'>
          {displayValue}
        </Typography>
      </div>
      <div style={{ height: '9px', marginTop: '4px' }}>
        <FuelGun fontSize='29px' />
      </div>
    </Stack>
  );
};
